import { AxiosInstance } from 'axios';
import { OrganizationsResponse } from 'data/terra/api/terra/response/OrganizationResponse';
import { result, Result } from 'util/result';

class OrganizationEndpoint {
  fetchOrganizationsUrl = () => `api/v1/organizations`;
}

export class OrganizationApi {
  terraClient: AxiosInstance;
  endpoint = new OrganizationEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  fetchOrganizations(): Promise<Result<OrganizationsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<OrganizationsResponse>(
            this.endpoint.fetchOrganizationsUrl()
          )
        ).data
    );
  }
}
